import { EntityCommand, EntityCommandPropertyValues, EntityCommandTypeEnum, IEntityCommand } from "@seriously-rad/seriouslyrad-framework-core/EntityCommand";
import { EntityCommandInformation } from "@seriously-rad/seriouslyrad-framework-core/EntityCommandInformation";
import { PartialNullable } from "@seriously-rad/seriouslyrad-framework-core/Extensions";
import { ObjectHelper } from "@seriously-rad/seriouslyrad-framework-core/Helpers/ObjectHelper";
import { Property } from "@seriously-rad/seriouslyrad-framework-core/RadObject";
import { GenericEvaluator } from "@seriously-rad/seriouslyrad-framework-core/Server/DotNet/SeriouslyRAD.Framework.Data.Entities/Evaluation/Evaluators/GenericEvaluator";
import { PermissionEvaluator } from "@seriously-rad/seriouslyrad-framework-core/Server/DotNet/SeriouslyRAD.Framework.Data.Entities/Evaluation/Evaluators/PermissionEvaluator";
import { WebApiClientService } from "@seriously-rad/seriouslyrad-framework-core/Server/WebApiClientService";
import { ServiceManager } from "@seriously-rad/seriouslyrad-framework-core/ServiceManager";
import { DialogResultEnum } from "@seriously-rad/seriouslyrad-framework-core/Ui/Dialogs/DialogResultEnum";
import { NAMESPACE } from "./_Namespace";

export type EntityCommandProcessInstanceItemReturnToPreviousTaskPropertyValues =
    EntityCommandPropertyValues
    & {
    };

export type EntityCommandProcessInstanceItemReturnToPreviousTaskProperties = {
    [name in keyof EntityCommandProcessInstanceItemReturnToPreviousTaskPropertyValues]: Property<EntityCommandProcessInstanceItemReturnToPreviousTaskPropertyValues[name]>
};

export interface IEntityCommandProcessInstanceItemReturnToPreviousTask extends IEntityCommand, EntityCommandProcessInstanceItemReturnToPreviousTaskProperties
{
}

export class EntityCommandProcessInstanceItemReturnToPreviousTask extends EntityCommand implements IEntityCommandProcessInstanceItemReturnToPreviousTask
{
    // #region Static

    public static override classNamespace = NAMESPACE + "EntityCommandProcessInstanceItemReturnToPreviousTask";
    public static override className = "EntityCommandProcessInstanceItemReturnToPreviousTask";

    // #region Overrides

    public static override createPropertyDefaults(): PartialNullable<EntityCommandProcessInstanceItemReturnToPreviousTaskPropertyValues>
    {
        return {
            ...super.createPropertyDefaults(),
            ...{
                description: "Return to Previous Task",
                entityName: "ProcessInstanceItem",
                key: "RETURN_TO_PREVIOUS_TASK",
                permission: PermissionEvaluator.permissionLevels.read,
                type: EntityCommandTypeEnum.entity,
                visibleEvaluator: new GenericEvaluator({
                    evaluateFn: (_, state) =>
                    {
                        if (!(state instanceof EntityCommandInformation))
                            return false;

                        if (state.record.get()?.statusLookupItem?.description !== "Pending")
                            return false;

                        return true;
                    }
                }),
            }
        };
    }
    public static override getRequiredFields()
    {
        return [
            ...super.getRequiredFields(),
            "processInstanceId",
            "statusLookupItem.description",
        ];
    }

    // #endregion

    // #endregion

    // #region Instance

    // #region Constructor

    constructor(propertyValues?: PartialNullable<EntityCommandProcessInstanceItemReturnToPreviousTaskPropertyValues>)
    {
        super(propertyValues);
    }

    // #endregion

    // #region Overrides

    protected override async _executeAsync(entityCommandInformation: EntityCommandInformation, value?: any)
    {
        await super._executeAsync(entityCommandInformation, value);

        const
            record = entityCommandInformation.record.get(),
            processInstanceId = entityCommandInformation.record.get()?.processInstanceId,
            processInstanceItemId = record?.id;

        if (!processInstanceItemId)
            return;

        if (!processInstanceId)
            return;

        const
            result =
                await
                    (await import("../Ui/Dialogs/ReturnToPreviousTaskDialog")).ReturnToPreviousTaskDialog.instance
                        .openAsync(processInstanceId);

        if (result.dialogResult !== DialogResultEnum.ok)
            return;

        const
            returnToProcessInstanceItemId = result.promiseData;

        await
            ServiceManager.getRequired(WebApiClientService)
                .createApiMethodRequest(
                    "DataService",
                    "CallDataService",
                    {
                        id: "B185975F-0E14-4944-B706-6353F0D67DC4",
                        operation: "ReturnToPreviousTaskProcessInstanceItem",
                        data: ObjectHelper.toJson({
                            processInstanceItemId,
                            returnToProcessInstanceItemId,
                            synchronousContinuation: true
                        })
                    },
                )
                .executeAsync();

        entityCommandInformation.caller.get()?.triggerHandler("activityChanged");
    }

    // #endregion

    // #endregion
}

